module.exports = __webpack_public_path__ + "img/sentosa-wave-orange.46438c89.svg";